import { GetServerSideProps } from "next";
import { ReactElement } from "react";
import HairStraightenerWrapper from "@components/layouts/hairstraightenerWrapper";

import { getPageProps } from "@services/initial-calls";
import PrivacyPolicy from "@components/shared/legal/privacyPolicy";

export default function HairStraightenerHome(): ReactElement {
    return (
        <HairStraightenerWrapper>
            <div className="w-full max-w-7xl mx-auto">
                <PrivacyPolicy
                    category="Hair Straightener"
                    domain="HairStraightener.claims"
                />
            </div>
        </HairStraightenerWrapper>
    );
}

export const getServerSideProps: GetServerSideProps = async (context) => {
    return await getPageProps(context, "home", { pageTitle: "Privacy Policy" });
};
